export default __webpack_public_path__ + "static/media/Barcode.b4f9b3ec.svg";